import type { RequestOtpPayload, VerifyOtpPayload } from "@groupeo/shared";
import { callWithRefresh, httpClient, setAccessToken } from "@/src/common/services/http.service";

export async function requestOtp(payload: RequestOtpPayload) {
	const { data, error } = await httpClient.auth["request-otp"].post(payload);
	if (error)
		throw new Error(
			typeof error.value === "object" && error.value && "error" in error.value ? String(error.value.error) : "request_otp_failed",
		);
	return data;
}

export async function verifyOtp(payload: VerifyOtpPayload) {
	const { data, error } = await httpClient.auth["verify-otp"].post(payload);
	if (error || !data) {
		throw new Error(
			typeof error?.value === "object" && error.value && "error" in error.value ? String(error.value.error) : "verify_otp_failed",
		);
	}
	setAccessToken(data.access_token);
	return data;
}

export async function fetchMe() {
	const { data, error } = await callWithRefresh(() => httpClient.user.me.get());
	if (error || !data) return null;
	return data;
}

export async function logoutClient() {
	try {
		await httpClient.auth.logout.post({});
	} catch {}
	setAccessToken(null);
}
